import { FC } from 'react';
import { Card } from '@/components/ui/card';
import { Crown, CheckCircle2, X } from 'lucide-react';

interface PremiumRequirementProps {
  isPremium: boolean;
}

export const PremiumRequirement: FC<PremiumRequirementProps> = ({ isPremium }) => {
  return (
    <Card className="p-4 bg-gradient-to-br from-primary/5 to-transparent border-primary/10">
      <div className="flex items-center gap-3 mb-3">
        <Crown className="h-5 w-5 text-primary" />
        <h3 className="font-semibold text-gray-800">Suscripción Premium</h3>
      </div>
      <div className="space-y-3">
        <div className="flex items-center gap-2">
          {isPremium ? (
            <CheckCircle2 className="h-5 w-5 text-green-500 shrink-0" />
          ) : (
            <X className="h-5 w-5 text-red-500 shrink-0" />
          )}
          <span className="text-sm text-gray-600">
            {isPremium 
              ? 'Tienes una suscripción premium activa' 
              : 'Para ser socio necesitas una suscripción premium activa'}
          </span>
        </div>
        {!isPremium && (
          <div className="space-y-2">
            <p className="text-sm text-gray-600">
              Como miembro premium podrás:
            </p>
            <ul className="text-xs text-gray-500 space-y-1 list-disc list-inside pl-1">
              <li>Acceder al programa de socios</li>
              <li>Ganar comisiones por referidos</li>
              <li>Obtener reportes detallados</li>
              <li>Acceder a contenido exclusivo</li>
            </ul>
          </div>
        )}
      </div>
    </Card>
  );
};